import React, {Component} from 'react'
import {Editor} from "react-draft-wysiwyg";
import {convertToRaw, EditorState} from 'draft-js';
import {Button} from "react-bootstrap";
import Select from 'react-select'
import draftToHtml from "draftjs-to-html";
import AdminService from "../AdminService";

export default class NowaStrona extends Component {

    constructor(props) {
        super(props);

        this.state = {
            tytul: '',
            tresc: EditorState.createEmpty(),
            kategoria: '',
            redirect: false,
            kategorie: [],
        };

        this.handleTytulChange = this.handleTytulChange.bind(this);
        this.handleKategoria = this.handleKategoria.bind(this);
        this.handleUrl = this.handleUrl.bind(this)
    }

    componentDidMount() {
        this.getKategorie()
    }

    onEditorStateChange = (editorState) => {
        this.setState({
            tresc: editorState,
        });
    };

    handleUrl(e) {
        this.setState({tresc: e.target.value})
    }

    handleTytulChange(e) {
        this.setState({tytul: e.target.value})
    }

    handleKategoria(e) {
        this.setState({kategoria: e})
    }

    getKategorie() {
        AdminService.getKategorie()
            .then(function (response) {
                for (let i = 0; i < response.data.content.length; i++) {
                    this.setState(prevState => ({
                        kategorie: [...prevState.kategorie, {
                            value: response.data.content[i].id,
                            label: response.data.content[i].nazwa
                        }]
                    }))
                }
            }.bind(this)).catch(err => {
            console.log(err)
        })
    }

    uploadStrona() {
        let tresc;
        if (this.state.redirect) {
            tresc = this.state.tresc
        } else {
            tresc = draftToHtml(convertToRaw(this.state.tresc.getCurrentContent()))
        }
        AdminService.postStrona("PAGE", this.state.tytul, tresc, true, {
            id: this.state.kategoria.value,
            nazwa: this.state.kategoria.label
        })
            .then(function (response) {
                this.props.goZarzadzanie()
            }.bind(this))
    }

    render() {
        return <div className="aktualnosciTabContainer">

            <div className="aktualnosciOpis">
                Aby dodać nową stronę należy uzupełnić wszystkie pola. Stronę można później edytować przez zakładkę
                <span style={{cursor: 'pointer'}} onClick={() => this.props.goZarzadzanie()}>
                    <b> zarządzanie</b>
                </span>.
            </div>
            <div className="nowyWpisForm">
                <div className="field">Tytuł:<font style={{color: 'red'}}>*</font>:
                    <input type="text" value={this.state.tytul} onChange={this.handleTytulChange}
                           className="form-control"/></div>
                <div className="field">
                    <input type="checkbox" checked={!this.state.redirect}
                           onChange={() => this.setState({redirect: false, tresc: EditorState.createEmpty()})}/> Treść
                    <input type="checkbox" checked={this.state.redirect}
                           onChange={() => this.setState({redirect: true, tresc: ''})}
                           style={{marginLeft: 15}}/> Przekierowanie
                </div>
                <div className="field">{this.state.redirect ? 'Adres linku:' : 'Treść:'}
                    {this.state.redirect ?
                        <input type="text" maxLength={100} value={this.state.tresc} className="form-control"
                               placeholder={'Podaj adres linku zaczynając od http://...'}
                               onChange={(e) => this.setState({tresc: e.target.value})}/>
                        : <Editor
                            editorState={this.state.tresc}
                            toolbarClassName="toolbarClassName"
                            wrapperClassName="wrapperEditor"
                            editorClassName="editorEditor"
                            onEditorStateChange={this.onEditorStateChange}
                        />}</div>
                <div className="field">Dodaj do folderu:
                    <Select
                        options={this.state.kategorie}
                        value={this.state.kategoria}
                        onChange={this.handleKategoria}
                        clearable={false}
                        placeholder={'Wybierz kategorię...'}
                    /></div>
                <hr/>
                <div className="text-right">
                    <Button bsStyle={this.state.tytul !== '' && this.state.kategoria !== '' ? 'success' : 'disabled'}
                            disabled={this.state.tytul === '' || this.state.kategoria === ''}
                            onClick={() => this.uploadStrona()}>Dodaj wpis</Button>
                </div>
            </div>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/admin/adminComponents/stronyComponents/NowaStrona.js